import { HubConnection } from '@microsoft/signalr';
import { createAppStore } from '@store/createAppStore';
import { SetStoreFunction } from 'solid-js/store';

import { SidebarDataStore, WarningDataStore } from './consts';
import { SidebarDataStoreType, WarningStoreType } from './types';

export type eventInfoType = {
  message: string;
  createdDate: string;
  messageType: string;
  createdBy: string;
  thumbnail: string | null;
  read: boolean;
  context: string;
  objectId: number;
  payloadJson?: string;
  payloadVersion?: number;
  payload?: unknown;
};

interface GlobalState {
  count: number;
  message: string;
  socketv: HubConnection | undefined;
  alertBox: {
    eventNameV3: string | null;
    eventName: string | null;
    show: boolean;
    data: {
      eventInfo: eventInfoType;
      message: string;
    };
  }[];
}

type GlobalStoreType = [GlobalState, SetStoreFunction<GlobalState>];

// @ts-expect-error - Create a global store
const [globalState, setGlobalState]: GlobalStoreType =
  createAppStore<GlobalState>(
    {
      count: 0,
      message: 'Hello, Solid!',
      socketv: undefined,
      alertBox: [],
    },
    'globalState',
  );

const [sidebarDataStore, setSidebarDataStore] =
  createAppStore<SidebarDataStoreType>(SidebarDataStore, 'sidebarDataStore');

const [warningDataStore, setWarningDataStore] =
  createAppStore<WarningStoreType>(WarningDataStore, 'warningDataStore');

// Functions to update global state
export const incrementCount = () => {
  setGlobalState((prev) => ({ count: prev.count + 1 }));
};

export const setSocketConnection = (socketv: HubConnection) => {
  setGlobalState((prev) => {
    return {
      ...prev,
      socketv,
    };
  });
};

export const updateMessage = (newMessage: string) => {
  setGlobalState(() => ({ message: newMessage }));
};

export {
  globalState,
  setGlobalState,
  setSidebarDataStore,
  setWarningDataStore,
  sidebarDataStore,
  warningDataStore,
};
